const ABLY_KEY = "DLUodA.c6Iz-Q:q5WKX3aLmbhf8oJxchkz2L-pbwbCae2DDtHJIg6rU84";
export default ABLY_KEY;